/* eslint-disable */

/** A users notifications settings */
export interface NotificationsSettings {
  options?: NotificationSettingsOption[];
}

export interface NotificationSettingsMessageConfig {
  /**
   * this maps to the settings option id as seen in NotificationSettingsOption
   * should be a value like 'STOCKS_OWNED_EARNINGS'
   */
  settings_option_id?: string;
  /**
   * this maps to the notification channel id in the push_sms.json in postmaster, it's the id
   * we send in the actual notification and is used by android to identify the message to the system.
   */
  notification_channel_id?: string;
}

export interface NotificationSettingsOption {
  /** An id of a specific settings option like 'STOCKS_OWNED_EARNINGS' or 'STOCKS_OWNED_PERFORMANCE' */
  id?: string;
  /** Whether the box is checked. */
  is_enabled?: boolean;
  /**
   * E.g., for perfomance based percentagess. If no configuration is needed,
   * this field will be null
   */
  configuration?: NotificationsSettingsOptionsConfiguration;
}

export interface NotificationsSettingsOptionsConfiguration {
  type?: NotificationsSettingsOptionsConfigurationNotificationsSettingsOptionsConfigurationType;
  performance?: NotificationsSettingsPerformanceConfiguration | undefined;
}

export enum NotificationsSettingsOptionsConfigurationNotificationsSettingsOptionsConfigurationType {
  UNKNOWN = "UNKNOWN",
  PERFORMANCE = "PERFORMANCE",
}

export interface NotificationsSettingsPerformanceConfiguration {
  value?: number;
}
